/// <reference path="../../../../components/common/payroll.service.ts" />
/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.Reports {

    import IPayRollYear = Meevo.Components.Common.IPayRollYear;
    import IPayRollListItem = Meevo.Components.Common.IPayRollListItem;
    import Employee = Meevo.Model.Employee;

    interface IPayRollSelectListItem extends IPayRollListItem {
        label: string;
    }

    function formatDateForRange(dateString: string): string {
        let date = new Date(dateString);

        return `${date.getMonth() + 1}/${date.getDate()}`;
    }

    function getUniquePeriodsForSelect(allPeriods: IPayRollListItem[]): IPayRollSelectListItem[] {

        return allPeriods.reduce((list: IPayRollListItem[], row: IPayRollListItem) => {

            if (!_.find(list, (item: IPayRollListItem) => {
                    return item.payrollEndDate === row.payrollEndDate
                        && item.payrollStartDate === row.payrollStartDate
                        && item.payrollPeriodId !== row.payrollPeriodId;
                })
            ) {
                list.push(row);
            }

            return list;
        }, <IPayRollListItem[]>[])
        .map((row: IPayRollListItem) => {
            return <IPayRollSelectListItem>{
                ...row,
                label: `${formatDateForRange(<string>row.payrollStartDate)} - ${formatDateForRange(<string>row.payrollEndDate)}`
            };
        });
    }

    class MeevoPayrollPeriodEmployeePickerComponent implements angular.IComponentController {

        static $inject = [
            '$q',
            'meevo.components.common.PayRollService'
        ];

        public payRollEmployees: any[] = [];

        public mainModel: Object;
        public parameterNames: string[];
        public securityAccess: any;
        public options: Object;

        public employeeCriteria = {};

        private _payRollYears: IPayRollYear[] = [];
        private _payrollPeriodSelectList: IPayRollSelectListItem[] = [];
        private _allPayrollPeriods: IPayRollListItem[] = [];
        private _selectedEmployee: Employee;

        private _payrollPeriodsCache: { [key: string]: IPayRollListItem[] } = {};

        get payRollYears(): IPayRollYear[] {
            return this._payRollYears;
        }

        get payrollPeriodSelectList(): IPayRollSelectListItem[] {
            return this._payrollPeriodSelectList;
        }

        get selectedYear(): IPayRollYear {
            return _.findWhere(this.payRollYears, <IPayRollYear>{payrollYear: this.mainModel[this.parameterNames[0]]});
        }

        set selectedYear(value: IPayRollYear) {
            this.mainModel[this.parameterNames[0]] = value.payrollYear;
            this.loadPayrollPeriod(value.startOfYear, value.endOfYear);
        }

        get selectedRange(): IPayRollSelectListItem {
            return _.findWhere(this.payrollPeriodSelectList, <IPayRollSelectListItem>{payrollPeriodId: this.mainModel[this.parameterNames[1]]});
        }

        set selectedRange(value: IPayRollSelectListItem) {
            this.mainModel[this.parameterNames[1]] = value.payrollPeriodId;

            this.employeeCriteria = {
                PayrollPeriodList_TBL: this.mainModel[this.parameterNames[1]]
            }
        }

        get selectedRangeDatesString(): string {
            return <string>this.selectedYear.startOfYear + <string>this.selectedYear.endOfYear;
        }

        get selectedEmployee(): Employee {
            return this._selectedEmployee;
        }

        set selectedEmployee(value: Employee) {
            this._selectedEmployee = value;
            if (value) {
                this.mainModel[this.parameterNames[2]] = value.id;
            }
        }

        constructor(private $q: angular.IQService,
                    private payRollService: Meevo.Components.Common.PayRollService) {
        }

        private loadPeriodYears() {
            return this.payRollService.getPayRollYears()
            .then(periodYears => this._payRollYears = _.sortBy(periodYears, (period: IPayRollYear) => period.payrollYear * (-1)));
        }

        private loadPayrollPeriod(startDate: string | Date, endDate: string | Date) {

            return new this.$q(resolve => {
                if (this._payrollPeriodsCache[this.selectedRangeDatesString] instanceof Array) {
                    resolve(this._payrollPeriodsCache[this.selectedRangeDatesString]);
                } else {
                    return this.payRollService
                    .getPayRollList({StartDate: startDate, EndDate: endDate})
                    .then(res => resolve(res));
                }
            }).then((payrollPeriod: IPayRollListItem[]) => {

                    this._payrollPeriodsCache[this.selectedRangeDatesString] = this._allPayrollPeriods = payrollPeriod;

                    this._payrollPeriodSelectList = getUniquePeriodsForSelect(payrollPeriod);

                    this.selectedRange = this._payrollPeriodSelectList[0];
                }
            );
        }

        $onInit() {
            this.loadPeriodYears();
        }

    }

    angular.module('meevo.plugins.reports')
    .component('meevoPayrollPeriodEmployeePickerComponent', <angular.IComponentOptions>{
        templateUrl: 'app/plugins/reports/components/payroll-period-employee-picker/payroll-period-employee-picker.component.html',
        controller: MeevoPayrollPeriodEmployeePickerComponent,
        controllerAs: '$ctrl',
        bindings: {
            mainModel: '<',
            parameterNames: '<',
            securityAccess: '<',
            options: '<',
        }
    });
}